import { FileText, Home, Award, Plane, HeartHandshake, Languages, FolderOpen, BadgeCheck, ShieldCheck } from "lucide-react";

const ICONS = {
  daca: FileText,
  aos: Home,
  "remove-conditions": BadgeCheck,
  "u-visa": ShieldCheck,
  citizenship: Award,
  "advance-parole": Plane,
  vawa: HeartHandshake,
  translation: Languages,
  other: FolderOpen,
};

export const SERVICE_ORDER = ["daca", "aos", "remove-conditions", "u-visa", "citizenship", "advance-parole", "vawa", "translation", "other"];

export default function ServiceIcon({ slug, className = "h-6 w-6" }) {
  const Icon = ICONS[slug] || FolderOpen;
  return <Icon className={className} strokeWidth={1.75} aria-hidden="true" />;
}
